import React from "react";
import { Button, Drawer } from "@mui/material";
import ProfileMenu from "../../components/profile/ProfileMenu";
import { useAppState } from "../../states/app-state";
import { Observer } from "mobx-react-lite";
import LoginPopup from "../login/LoginPopup";
import MenuDrawer from "../../containers/menudrawer/MenuDrawer";
import styles from './BearerMenu.module.scss'; // added by Bearer Web Developer
import { useMenuDrawer } from "../../states/contexts/menuDrawer"; // added by Bearer Web Developer
import CompleteProfileButton from "./completeProfileButton"; // added by Bearer Web Developer
import ToggleTheme from "../toggleTheme"; // added by Bearer Web Developer
import { useThemeMode } from "../../states/contexts/theme"; // added by Bearer Web Developer
// useStyles removed by Bearer Web Developer

export default function BearerMenu() {

    const appState = useAppState();
    const sign_up_stage = appState?.createAccount?.sign_up_stage; // added by Bearer Web Developer
    // move login state to loginState of mobx states by Bearer Web Developer
    const handleOpenLoginPopup = () => {
        appState.login.setOpen(true); // modified by Bearer Web Developer (login state is moved to loginState of mobx states)
    }
    // const handleCloseLoginPopup = () => { // commented by Bearer Web Developer (not needed)
    //     appState.login.setOpen(false);
    // }
    const menuDrawer = useMenuDrawer(); // added by Bearer Web Developer
    // modified by Bearer Web Developer start
    const { theme } = useThemeMode(); // added by Bearer Web Developer
    return (
        <Observer>{() => (
            <>
                <LoginPopup open={appState.login?.open} />
                <div className={styles.root} data-theme={theme}> {/* data-theme property added by Bearer Web Developer */}
                    <div className={styles.actions}>
                        <MenuDrawer />
                    </div>
                    {/* modified by Bearer Web Developer start (add CompleteProfileButton and sign_up_stage) */}
                    <div className={styles.actions}>
                        <ToggleTheme /> {/* added by Bearer Web Developer */}
                        {appState.login.loggedin ? <ProfileMenu /> :
                            (sign_up_stage !== 0) ? <CompleteProfileButton /> :
                                <Button className={styles.login} onClick={handleOpenLoginPopup}
                                    disableRipple={true}>Log in</Button>
                        }
                    </div>
                    {/* modified by Bearer Web Developer end (add CompleteProfileButton and sign_up_stage) */}
                    {/* added for mobile screen by Bearer Web Developer start */}
                    {
                        appState.login.loggedin &&
                        <Drawer
                            anchor={'left'}
                            open={menuDrawer.openDrawer}
                            onClose={menuDrawer.toggleMenuDrawer(false)}
                            PaperProps={{ style: { background: "none", boxShadow: "none" } }}
                            className={styles.main_drawer_menu}
                        >
                            <div className={styles.drawer_menu} data-theme={theme}> {/* data-theme property added by Bearer Web Developer */}
                                <div className={styles.drawer_menu_items}>
                                    <div className={styles.actions}>
                                        <ToggleTheme /> {/* added by Bearer Web Developer */}
                                        <MenuDrawer />
                                    </div>
                                    <div className={styles.actions}>
                                        <ProfileMenu />
                                    </div>
                                </div>
                            </div>
                        </Drawer>
                    }
                    {/* added for mobile screen by Bearer Web Developer end */}
                </div>
            </>
        )}</Observer>
    );
    // modified by Bearer Web Developer end
}
